import React, { useState, useEffect } from 'react'

import { PharmacyGetConsentEmailData, PharmacyAddConsentEmailData } from '../../../services/reducers/pharmacy/other/commonReducerForInitalData'
import { useCommonReducerSelector } from '../../../services/selectors/commonReducerSelector'
import { ProfilePicLoader } from '../../../components/common/loadingView'
import { ModalCloseIcon } from '../../../assets/svg/icons'
import { useDispatch } from 'react-redux'

const ConsentToEmail = () => {

    const [showModal, setShowModal] = useState(false)
    const [primaryEmail, setPrimaryEmail] = useState('')
    const [additionalEmails, setAdditionalEmails] = useState([])

    const { pharmacyGetConsentEmailDataResponse, pharmacyAddConsentEmailDataResponse } = useCommonReducerSelector()
    const dispatch = useDispatch()



    const handleModal = () => {
        dispatch(PharmacyGetConsentEmailData({ fetchType: 'pharmacyGetConsentEmailData' }))
        setShowModal(true)
    }

    useEffect(() => {
        if (pharmacyGetConsentEmailDataResponse?.data) {
            setPrimaryEmail(pharmacyGetConsentEmailDataResponse?.data?.primary_email)
            setAdditionalEmails(pharmacyGetConsentEmailDataResponse?.data?.consent_form_email?.map(item => item?.email))
        }
    }, [pharmacyGetConsentEmailDataResponse])

    const handleAddEmail = () => {
        setAdditionalEmails([...additionalEmails, ''])
    }

    const handleRemoveEmail = (index) => {
        setAdditionalEmails(additionalEmails.filter((_, i) => i !== index))
    }

    const handleChangeEmail = (index, value) => {
        setAdditionalEmails(additionalEmails.map((email, i) => i === index ? value : email))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(PharmacyAddConsentEmailData({ auth_emails: additionalEmails, fetchType: 'pharmacyAddConsentEmailData' })).finally(() => {
            setShowModal(false)
        })
    }


    return (
        <>
            <li onClick={handleModal} className="btnnn">
                <a className="flex gap-4 items-center px-5 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white grey-color rubik-400 fs-16">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M2.94 6.94A2 2 0 014.34 6h11.32a2 2 0 011.4.94l-7.06 4.42a1 1 0 01-1.08 0L2.94 6.94z" />
                        <path d="M18 8.08V14a2 2 0 01-2 2H4a2 2 0 01-2-2V8.08l7.39 4.62a3 3 0 003.22 0L18 8.08z" />
                    </svg> Consent Form Email
                </a>
            </li>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
                    <div className="bg-white rounded-lg w-[500px] ">
                        <div className="flex justify-between items-center px-6 py-4">
                            <h2 className="text-xl font-semibold">Consent Form Emails</h2>
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-tableHeader text-white rounded-full p-1 w-6 h-6 flex items-center justify-center"
                            >
                                <ModalCloseIcon />
                            </button>
                        </div>
                        <hr className='border-t border-gray-200' />
                        {pharmacyGetConsentEmailDataResponse?.loading ?
                            <div className='flex justify-center items-center h-[200px]'>
                                <ProfilePicLoader color='black' />
                            </div> :
                                <form onSubmit={handleSubmit} className="px-6 py-4 space-y-4">
                                <div>
                                    <label className="block text-sm font-semibold mb-1">Primary Email</label>
                                <input
                                    type="email"
                                    value={primaryEmail}
                                    disabled
                                    className="w-full border border-gray-200 bg-gray-100 rounded-md p-2 text-gray-500 cursor-not-allowed"
                                />
                            </div>
                            <div>
                                <div className="flex items-center mb-1">
                                    <label className="block text-sm font-semibold">Additional Emails</label>
                                    <button type="button" onClick={handleAddEmail} className="ml-2 text-green-700 text-lg font-bold focus:outline-none">+</button>
                                </div>
                                {additionalEmails?.map((value, idx) => (
                                    <div key={idx} className="flex items-center mb-2">
                                        <input
                                            type="email"
                                            value={value}
                                            onChange={e => handleChangeEmail(idx, e.target.value)}
                                            className="w-full border border-gray-200 rounded-md p-2"
                                            placeholder="Enter email"
                                        />
                                        <button type="button" onClick={() => handleRemoveEmail(idx)} className="ml-2 text-red-600 hover:text-red-800 text-xl">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M8 7V5a2 2 0 012-2h2a2 2 0 012 2v2" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <button type="submit" className="w-full bg-blue-700 text-white rounded py-2  flex justify-center items-center">

                                {pharmacyAddConsentEmailDataResponse?.loading && <ProfilePicLoader color='white' />}
                                <span className='ml-2'>Update</span>
                            </button>
                            </form>
                        }
                    </div>
                </div>
            )}
        </>
    )
}

export default ConsentToEmail